import { Subject } from 'rxjs';

const subject = new Subject();

export const annotationService = {
  emitReload: val => subject.next(val),
  reload: () => subject.asObservable()
};